export enum FormalityCodeNameEnum {
  accountsApproval = 'accounts_approval',
  companyCreation = 'company_creation',
  capitalIncomeDeclaration = 'capital_income_declaration',
  capitalDeposit = 'capital_deposit'
}
